import { useEffect, useState } from "react";
import { getReport, updateReportCallouts } from "../utils/reportManager";

export function useReportCallouts(reportId?: string) {
  const [callouts, setCallouts] = useState<string>("");
  const [isEditingCallouts, setIsEditingCallouts] = useState(false);
  const [showCallouts, setShowCallouts] = useState(false);

  useEffect(() => {
    if (!reportId) {
      setCallouts("");
      setShowCallouts(false);
      return;
    }

    const savedReport = getReport(reportId);
    if (savedReport?.callouts) {
      setCallouts(savedReport.callouts);
      setShowCallouts(Boolean(savedReport.callouts.trim()));
      return;
    }

    setCallouts("");
    setShowCallouts(false);
  }, [reportId]);

  const saveCallouts = () => {
    if (!reportId) {
      return;
    }

    updateReportCallouts(reportId, callouts);
    setIsEditingCallouts(false);
    if (callouts.trim()) {
      setShowCallouts(true);
    }
  };

  const cancelEdit = () => {
    if (reportId) {
      const savedReport = getReport(reportId);
      setCallouts(savedReport?.callouts || "");
    }
    setIsEditingCallouts(false);
  };

  const deleteCallouts = () => {
    if (!reportId) {
      return;
    }

    setCallouts("");
    updateReportCallouts(reportId, "");
    setShowCallouts(false);
    setIsEditingCallouts(false);
  };

  const beginEditing = () => {
    setIsEditingCallouts(true);
  };

  const beginAdding = () => {
    setIsEditingCallouts(true);
    setShowCallouts(true);
  };

  const appendCallout = (calloutText: string) => {
    setCallouts((currentCallouts) => {
      const nextCallouts = currentCallouts.trim()
        ? `${currentCallouts}\n\n${calloutText}`
        : calloutText;

      if (reportId) {
        updateReportCallouts(reportId, nextCallouts);
      }

      return nextCallouts;
    });
    setShowCallouts(true);
  };

  return {
    appendCallout,
    beginAdding,
    beginEditing,
    callouts,
    cancelEdit,
    deleteCallouts,
    isEditingCallouts,
    saveCallouts,
    setCallouts,
    showCallouts,
  };
}
